import * as RadixDialog from '@radix-ui/react-dialog'
import * as VisuallyHidden from '@radix-ui/react-visually-hidden'
import styled, { css } from 'styled-components'

import { Close3Icon } from '@blade/ui-kit'
import { mediaMaxMobile } from '@blade/ui-theme'
import { useTranslation } from '@root/shared/localization'
import { centeredDialogContentCss, DialogOverlay } from '@root/shared/ui-kit'

import type { ChildrenProps } from '@root/shared/react'
import type { DialogControlProps } from '@root/shared/ui-kit'

export type AuthDialogProps = DialogControlProps &
  ChildrenProps & {
    onClose?: () => void
  }

export const AuthDialog = ({
  open,
  onOpenChange,
  onClose,
  children,
}: AuthDialogProps) => {
  const { t } = useTranslation()
  return (
    <StyledDialog open={open} onOpenChange={onOpenChange}>
      <RadixDialog.Portal>
        <DialogOverlay />
        <Content>
          <VisuallyHidden.Root>
            <RadixDialog.Description>
              {t('common.auth')}
            </RadixDialog.Description>
          </VisuallyHidden.Root>
          {children}
          <Close
            onClick={() => {
              onClose?.()
              onOpenChange?.(false)
            }}
          >
            <Close3Icon size={18} />
          </Close>
        </Content>
      </RadixDialog.Portal>
    </StyledDialog>
  )
}

const StyledDialog = styled(RadixDialog.Root)``

const Content = styled(RadixDialog.Content)`
  ${centeredDialogContentCss}
  padding: 10px 18px;

  ${mediaMaxMobile(css`
    padding: 0;
  `)}
`

const Close = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  color: var(--textA-9);
  cursor: pointer;

  &:hover {
    color: var(--textA-10);
  }

  ${mediaMaxMobile(css`
    top: 12px;
    right: 12px;
  `)}
`
